import { render, staticRenderFns } from "./formRelatedProduct.vue?vue&type=template&id=2682ae0d&scoped=true&"
import script from "./formRelatedProduct.vue?vue&type=script&lang=js&"
export * from "./formRelatedProduct.vue?vue&type=script&lang=js&"
import style0 from "./formRelatedProduct.vue?vue&type=style&index=0&id=2682ae0d&scoped=true&lang=css&"
import style1 from "./formRelatedProduct.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2682ae0d",
  null
  
)

export default component.exports